import { render, staticRenderFns } from "./CostInfoModal.vue?vue&type=template&id=65588ae9&"
import script from "./CostInfoModal.vue?vue&type=script&lang=js&"
export * from "./CostInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports